module.exports = __webpack_public_path__ + "static/media/stop-4.29e3c8df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-4.svg
// module id = 1371
// module chunks = 0